import { Component } from 'san';
import * as _ from 'lodash';
import { Select } from 'santd';


import { IOrganization } from 'src/models';
import LeanInputCell from '../LeanInputCell/LeanInputCell';

import checkOrganizationService from 'src/services/checkOrganization.service';
import organizationService from 'src/services/organization.service';
import { EOrgType } from 'src/enums';
import ssoService from 'src/services/sso.service';
import leanService from 'src/services/lean.service';

export default class LeanProjectUnit extends Component {
    static components = {
        'ui-lean-input-cell': LeanInputCell,
        's-select': Select,
        's-select-option': Select.Option,
    };

    static computed = {
        handlerIds() {
            const value = this.data.get('value');
            return value ? [value.org_number] : [];
        }
    };

    constructor(options: any) {
        super(options);
    }

    initData(): {
        focusId: string;    // {{}} 当前focus的组件的id，用来高亮组件
        id: string; // {{}}
        title: string;  // {{}}
        value: IOrganization;   // {==}
        cachedItems: IOrganization[];   // {{}} 缓存列表（初始化时应传入包含 value 的列表，使用中追加记录选中的，以保证Select label正常显示）
        items: IOrganization[];   // 搜索列表
        isRequired: boolean;    // {{}}
        orgTypeEnum: any;
        isSso: boolean;
    } {
        return {
            focusId: null,
            id: null,
            title: '',
            value: null,
            cachedItems: [],
            items: [],
            isRequired: false,
            orgTypeEnum: EOrgType,
            isSso: false,
        };
    }

    inited(): void {
        this.initItems();
        this.getIsSso();
        this.watch('value', value => {
            if (value) {
                const items = _.unionBy(_.concat([value], this.data.get('items')), 'org_number');
                this.data.set('items', items);
            }
        });
    }

    handleSearch(q: string) {
        organizationService.getOrganizations(q, false).then((organizations) => {
            this.data.set('items', organizations);
        });
    }

    handleChange(codes: string[]) {
        if (!codes) {
            return;
        }

        const items = this.data.get('items');
        const value = _.find(items, (item) => {
            return _.includes(codes, item.org_number);
        });
        this.data.set('value', value);
        this.fireValueChange(value);
    }

    onFocus() {
        this.initItems().then(() => {
            (this.ref('select') as any).setOpenState(true); // santd Select 获取焦点并打开下拉框
            this.fire('focus', this.data.get('id'));
        });
    }

    onBlur() {
        (this.ref('select') as any).setOpenState(false); // santd Select 移除焦点并关闭下拉框
        this.fire('blur', this.data.get('id'));
    }

    onClick() {
        this.onFocus();
    }

    toCheckUnit() {
        checkOrganizationService.show({
            callback: (organization) => {
                this.checkUnit(organization);
            },
        });
    }
    checkUnit(checkedItem: IOrganization) {
        if (!checkedItem) {
            return;
        }
        this.getLatelyOrganizations().then(latelyOrgs => {
            const items = _.unionBy(_.concat(checkedItem, latelyOrgs), 'org_number');
            this.data.set('items', items);
        });
        this.data.set('value', checkedItem);
        this.fireValueChange(checkedItem);
    }

    fireValueChange(value: IOrganization) {
        this.fire('value-change', value);
    }

    initItems(): Promise<IOrganization[]> {
        // 默认取 最近列表 + 缓存列表
        // 若最近列表为空，则取 列表 + 缓存列表
        let items = this.data.get('items');
        const cachedItems = this.data.get('cachedItems');
        return this.getLatelyOrganizations().then(latelyOrgs => {
            if (latelyOrgs.length) {
                return latelyOrgs;
            } else {
                return this.getOrganizations();
            }
        }).then(orgs => {
            // 将已选中的值放在首个
            const value = this.data.get('value');
            const valueArray = value ? [value] : [];
            items = _.unionBy(_.concat(valueArray, orgs, cachedItems), 'org_number');
            this.data.set('items', items);
            return items;
        });
    }

    /*private*/ getOrganizations(q?: string): Promise<IOrganization[]> {
        return organizationService.getOrganizations(q, false);
    }
    /*private*/ getLatelyOrganizations(): Promise<IOrganization[]> {
        return organizationService.getLatelyOrganizations();
    }

    getPopupContainer() {
        return () => this.el;
    }

    onDropdownVisibleChange(open: boolean) {
        leanService.patchOnDropdownVisibleChange(open, this.el, this.data.get('value'), this.data.get('items'));
    }

    getIsSso() {
        const isSso = ssoService.getIsSso();
        this.data.set('isSso', isSso);
    }

}
